import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import StockNotesService from "../../Controller/PartNotesControlller";
import CreatePartNotes from "./CreatePartNotes";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function PartNotesPage({ StockID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const tableRef = useRef();
    const [NotesList, setNotesList] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentNotes, setCurrentNotes] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (NotesList.length > 0) {
            initDataTable();
        }
    }, [StockID, NotesList]);

    const fetchNotes = async () => {
        try {
            setLoading(true);
            $(tableRef.current).DataTable().destroy();

            const data = await StockNotesService.GetStockNotes(redirectCallback, StockID);

            setNotesList(data);
        } catch (error) {

            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    useEffect(() => {
        if (StockID > 0) {
            fetchNotes();

        }
    }, [StockID]);

    const handleCreateNotesClick = () => {
        setCurrentNotes(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        setCurrentNotes(history);
        setIsModalOpen(true);
    };
    const handleSuccess = () => {
        debugger;
        fetchNotes(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    debugger;
                    await StockNotesService.DeleteStockNotes(redirectCallback, ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchNotes();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateNotesClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>

                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="table-responsive">
                        <table className="table m-0 table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th style={{ "width": "70%" }}>Notes</th>
                                    <th style={{ "width": "20%" }}>Action By</th>
                                    <th style={{ "textAlign": "right", "width": "10%" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {NotesList.map((note) => (
                                    <tr key={note.ID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(note) : undefined} style={{ cursor: 'pointer' }}>

                                        <td style={{ "width": "70%" }} dangerouslySetInnerHTML={{ __html: note.Notes }}></td>
                                        <td style={{ "width": "20%" }} >{note.DisplayName}</td>
                                        <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right", "width": "10%" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, note.ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreatePartNotes
                    modalInstance={modalInstance}
                    currentNotes={currentNotes}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    StockID={StockID}


                />
            )}
        </div>
    );
}

export default PartNotesPage;
